export default "__VITE_ASSET__Bua1f46T__"